module.exports = __webpack_public_path__ + "img/blog-recover-deleted-messages.835c02b0.webp";